module.exports = __webpack_public_path__ + "img/video-poster.765d3328.jpg";